/*
 * @Author: your name
 * @Date: 2021-03-16 10:07:44
 * @LastEditTime: 2021-06-10 11:35:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \cdlmdm-wps\src\view\POH\util\util.js
 */
import http from '@/assets/js/http'
import { baseStore } from '@/assets/js/base-url.js'

export const pohStatusMap = (status) => {
    let statusArr = {
        unApprove: "待审批",
        Done: "已完成",
        Reject: "已拒绝",
        Draft: "未提交",
        HistoryData: "历史数据",
        Recall: "已撤回",
    };
    let returnVal = status
    for (const key in statusArr) {
        if (key === status) {
            returnVal = statusArr[key];
        }
    }
    return returnVal;
}

// 获取当前用户的代理信息
// setCache 是否设置缓存
export const getDelegationsByUser = (setCache = false) => {
    return new Promise((reslove, reject) => {
        localStorage.removeItem('delegateList');
        localStorage.removeItem('current_delegation');
        let url = `${baseStore}/poh/delegate/getCurrentUserDelegations`;
        http.get(url).then(res => {
            if (setCache) {
                localStorage.setItem('delegateList', JSON.stringify(res.data));
                // 设置代理人信息，为了写进请求头
                let obj = {
                    "DELEGATED-USERNAME": res.data[0].username,
                    "DELEGATED-ROLE": res.data[0].delegated_role,
                };
                localStorage.setItem('current_delegation', JSON.stringify(obj));
            }
            reslove(res.data);
        }).catch( err => {
            console.log(err, "获取当前用户代理信息出错");
            if (setCache) {
                localStorage.setItem('delegateList', JSON.stringify([]));
            }
            reslove([]);
        })
    })
}



// WEBPACK FOOTER //
// ./src/view/POH/util/util.js